// extracted by mini-css-extract-plugin
export default {"container":"src-client-components-SchibstedBrands-styles-___default__container___T+I7u"};